import "./dbh_popups";
import '../ClientValidation/index.ts';
import '../Abrechnungen/index.ts';
import '../Adressen/index.ts';
import '../Belegungen/index.ts';
import '../Beschwerdemanagement/index.ts';
import '../Betreuungsberichte/index.ts';
import '../Leistungsnachweise/index.ts';
import '../Stammdaten/index.ts';
import '../Listen/index.ts';
import '../Home/index.ts';
import '../Profil/details';
import '../Workflows/Index.ts';
import '../../Booklet/Scripts/Src/booklet_main.ts';
import '../Controls/dbh_menu.ts';
import '../Controls/dbh_suche.ts';
import '../Controls/dbh_suchergebnis';
import '../Controls/dbh_breadcrumb';
import '../Controls/dbh_history';
import "./dbh_notifications";
//import * as $ from "jquery"; // Import des Moduls geht zwar, führ aber zu Problemen beim Compilieren durch webpack....
import { dbh_helper } from "./dbh_helper";
import { dbh_ajax } from "./dbh_ajax";
import { dbh_loading } from "./dbh_loading";
import { dbh_filePreview } from "../Controls/dbh_filePreview";
import { dbh_numberFormatChangeDE } from "./dbh_numberFormatChangeDE";
const isDesktop = () => {
    // Einsatz von vanilla-Javascript, da dieses deutlich schneller ist als die jquery-Variante
    /* Da die Breite der Website (des Browsers) nicht als eindeutiges Anzeichen für die aktuelle
     * Ansichtsform gelten kann (einige Browser rechnen für die Breite der Seite die Scrollbar mit hinein, andere nicht), wird
     * zur Ermittlung, ob es sich um die Desktop-Ansicht handelt, auf die Sichtbarkeit eines Elements bezogen*/
    return window.getComputedStyle(document.getElementById("desktopDetector"), null).display === "block";
}

$(document).ready(function () {
    initMenu();

    dbh_helper.setDefaultFormValues();


    $(document).submit(function () {
        if (performance && performance.getEntriesByType) {
            const navEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
            if (navEntries.length > 0 && navEntries[0].type === "back_forward") {
                // Seite wurde aus dem bfcache geladen, keine Ladeanzeige!
                return true;
            }
        }
        dbh_helper.BeginSubmitHandler();
    });

    window.onbeforeunload = function (e) {
        if (performance && performance.getEntriesByType) {
            const navEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
            if (navEntries.length > 0 && navEntries[0].type === "back_forward") {
                // Seite wurde aus dem bfcache geladen, keine Ladeanzeige!
                return;
            }
        }
        if (!$(document.activeElement).hasClass("btnDownload")) {
            dbh_helper.BeginSubmitHandler();
        }
    };

    initSearch();

    $(".dbh_action.weitereOptionen").on("click", function () {
        $(".dbh_actionContainer_subMobile").toggleClass("active");
    });

    initObjectHistory();

    initDefaultUploadEvents();

    initInfoBanner();

    $(".typescriptProxyGet").on("click", function (event, actionName, controllerName, parameter, htmlId, doOnSuccess) {
        return new dbh_ajax().sendGetRequest({
            actionName: actionName,
            controllerName: controllerName,
            parameter: parameter,
            callbackSuccess: (ajaxResult: any) => {
                $("#" + htmlId).html(ajaxResult.responseText);
                doOnSuccess();
            },
            callbackError: (ajaxResult: object) => {

            }
        });
    });

    /* DateTime & Co Felder werden immer als Textfeld angezeigt und erst beim Fokus/Klick auf DateTime umgestellt. 
     * Grund dafür ist das Styling der Elemente sowie die Darstellung der Datumsformate (mit/ohne Uhrzeit im deutschen Format).
     * Problem ist, dass bei iOS die Umschaltung von Text auf bspw. Date nicht geht, da der Vorgang durch das Einblenden der 
     * Bildschirm Tastatur "abgebrochen" wird. Daher soll bei iOS direkt das DateTime Feld angezeigt werden.
    */
    if (!dbh_helper.isIOS()) {
        initDateTimeExtras();
    } else {
        $(".dpContainer").each(function (item, element) {
            dateTimeAddClearElement($(element));
        });
    }

    initImagePreview();

    // Initialisiert das Objekt und führt automatisch die Formatierung der Zahlen durch
    // Alle Zahlen erhalten ein Tausender-Trennzeichen
    // Inputs werden vor Submit wieder zurück gesetzt
    new dbh_numberFormatChangeDE();
});

const initDateTimeExtras = () => {
    $(document).off("focus", ".dpContainer");
    $(document).off("mouseenter", ".dpContainer");
    $(document).off("touchstart", ".dpContainer");
    $(document).off("focusout", ".dpContainer");
    $(document).off("mouseleave", ".dpContainer");
    $(document).off("touchend", ".dpContainer");

    $(document).on("focus", ".dpContainer", function () {
        dateTimeAddClearElement($(this));
    });
    $(document).on("mouseenter", ".dpContainer", function () {
        dateTimeAddClearElement($(this));
    });
    $(document).on("touchstart", ".dpContainer", function (e) {
        dateTimeAddClearElement($(this));
        e.preventDefault();
    });

    $(document).on("focusout", ".dpContainer", function () {
        dateTimeRemoveClearElement($(this));
    });
    $(document).on("mouseleave", ".dpContainer", function () {
        dateTimeRemoveClearElement($(this));
    });
    $(document).on("touchend", ".dpContainer", function (e) {
        dateTimeRemoveClearElement($(this));
        e.preventDefault();
    });
}

const initImagePreview = () => {
    const fileHandler: dbh_filePreview = new dbh_filePreview();
    $(document).on("click", ".zoomOut", function () {
        fileHandler.zoomImg($(this), -100);
    });

    $(document).on("click", ".zoomIn", function () {
        fileHandler.zoomImg($(this), 100);
    });

    $(document).on("click", ".filePrev, .fileNext", function () {
        const id = $(this).data("id");
        const isAufgabe = $(this).data("isaufgabe");

        fileHandler.loadPrevNextImage(id, isAufgabe);
    })

    fileHandler.initTurnRight();
};

const dateTimeAddClearElement = (element) => {
    let datepicker = element.find(".form-text-datepicker");

    if (datepicker.length === 0) {
        datepicker = element.find(".form-text-datetimepicker");
    }

    if (datepicker.length === 0) {
        datepicker = element.find(".form-text-timepicker");
    }

    if (!datepicker.prop('disabled') && datepicker.val().toString().trim().length > 0) {
        if (!element.hasClass("clearAdded")) {
            const div = document.createElement("div");
            div.classList.add("clearDT");

            element.css("position", "relative");
            element.append(div);
            element.addClass("clearAdded");

            $(div).on("click", function () {
                datepicker.val("");
                element.removeClass("clearAdded");
                element.find(".clearDT").remove();
                datepicker.focus();
            })
        }
    }
}

const dateTimeRemoveClearElement = (element) => {
    const datepicker = element.find(".form-text-datepicker");
    if (!datepicker.is(":focus") && !element.is(":hover")) {
        element.removeClass("clearAdded");
        element.find(".clearDT").remove();
    }
}

let inAnimation = false;

function initMenu() {
    $(".dbh_navIcon").on("click", function () {
        let $this = $(this);
        const $allNavIcons = $(".dbh_navIcon");
        const isActive = $this.hasClass("active");
        const oldActive = $(".dbh_dropDown.active");
        const isDesktopView = isDesktop();

        // Ermitteln der navIcon-Subklasse 
        let subclass = $($this[0].classList).toArray().find(l => l.toString().indexOf("nav-") >= 0)?.replace("nav-", "") + "";
        if (subclass.length === 0 || subclass === "account") {
            return;
        }

        if (isDesktopView && (/*subclass === "account" ||*/ subclass === "info" || subclass === "settings")) {
            handleDesktopPopin(subclass);
            return;
        }

        const $navDropdown = $(".dbh_dropDown." + subclass);
        if ($navDropdown.length === 0) {
            return;
        }

        if (!isDesktopView) {
            $allNavIcons.removeClass("active");
        }

        if (!isActive) {

            if (subclass === 'search') {
                $navDropdown.find("input[type=text]").focus();
            }

            if (!inAnimation) {
                inAnimation = true;
                $navDropdown.addClass("active focus");
                $this.addClass("active");
                setTimeout(function () {
                    $navDropdown.removeClass("focus");
                    if (!isDesktopView && oldActive.length > 0) {
                        oldActive.removeClass("active")
                    }
                    inAnimation = false;
                }, 500);
            }
        } else {
            $navDropdown.removeClass("active");
            $this.removeClass("active");
        }
    });

    $(".dbh_dropDown .dbh_dropDown-buttonContainer .close").on("click", function () {
        const $allNavIcons = $(".dbh_navIcon");
        const $navDropdown = $(this).closest(".dbh_dropDown");

        $allNavIcons.removeClass("active");
        $navDropdown.removeClass("active");
    });

    function handleDesktopPopin(subclass) {
        //alert("not implemented");
    }

    $(".dbh_logoSwitch").on("click", function () {
        const switchContainer = $("#dbh_obvSwitchContainer");
        switchContainer.addClass("active");
    });

    $(".dbh_switchImage").on("click", function () {
        const clickedElement = $(this);
        const container = $("#dbh_obvSwitchContainer");
        const logo = $("#logo");

        if (!clickedElement.hasClass("active")) {
            $(".dbh_switchImage").removeClass("active");
            clickedElement.addClass("active");
            const type = clickedElement.data().type;
            if (type === "stiftung") {
                logo.removeClass("verein");
                logo.addClass("stiftung");
            } else {
                logo.removeClass("stiftung");
                logo.addClass("verein");
            }

            new dbh_ajax().sendGetRequest({
                actionName: 'SwitchApp',
                controllerName: '',
                callbackSuccess: (ajaxResult: any) => {
                    window.location.href = "/index";
                },
                callbackError: (ajaxResult: object) => {
                }
            });
        }
        container.removeClass("active");
    });
}

function initSearch() {
    $(".dbhSearch-openDetail-Btn").on("click", function () {
        const $this = $(this);

        $this.toggleClass("active");
        localStorage.setItem('rememberOpenDetailsStatus', $this.hasClass("active") ? 'open' : 'closed');
        localStorage.setItem('rememberOpenDetailsUrl', window.location.pathname);

        $(".dbhRowsHolder.secondary").slideToggle();
    });

    if (localStorage.getItem('rememberOpenDetailsStatus') != null && localStorage.getItem('rememberOpenDetailsStatus') == 'open' && localStorage.getItem('rememberOpenDetailsUrl') == window.location.pathname) {
        $(".dbhSearch-openDetail-Btn").toggleClass("active");
        $(".dbhRowsHolder.secondary").show();
    }

    $(".resetSearch").on("click", function () {
        localStorage.setItem('rememberOpenDetailsStatus', 'closed');
        localStorage.setItem('rememberOpenDetailsUrl', window.location.pathname);

        const $this = $(this);
        const $searchContainer = $this.closest(".dbhSuche");
        const $inputTexts = $searchContainer.find("input[type='text']");
        const $inputCheckboxes = $searchContainer.find("input[type='checkbox']");
        const $inputRadio = $searchContainer.find("input[type='radio']");
        const $inputSelect = $searchContainer.find("select");

        if ($inputTexts.length > 0) {
            $inputTexts.val("");
            $inputTexts.text("");
        }

        if ($inputCheckboxes.length > 0) {
            for (let i = 0; i < $inputCheckboxes.length; i++) {
                const $curCheck = $($inputCheckboxes[i]);
                const dataStandardChecked = $curCheck.data("checkedonstandard");
                /*Damit beim Verwerfen die Checkboxen ihren ursprünglichen Standartwert 
                 * erhalten - Wert wird im Model(-Attribute) gesetzt*/
                if (!dataStandardChecked) {
                    $curCheck.prop("checked", "");
                }
                else {
                    $curCheck.prop("checked", dataStandardChecked ? "checked" : "");
                }
            }
        }

        if ($inputRadio.length > 0) {
            for (let i = 0; i < $inputRadio.length; i++) {
                const $curRadio = $($inputRadio[i]);
                $curRadio.prop("checked", "");
            }
        }

        if ($inputSelect.length > 0) {
            for (let i = 0; i < $inputSelect.length; i++) {
                $inputSelect[i].selectedIndex = 0;
            }
        }

        const $submit = $this.closest(".btnRow").find(".submitSearch");
        $submit.trigger("click");
    });

    initGlobalSearchElements("chkBoxSearch", "chkBoxSearchAll");
    initGlobalSearchElements("chkMenuSearch", "chkMenuSearchAll");
}

function initGlobalSearchElements(chkClass, chkAllClass) {
    $(`.${chkClass}`).on("change", function () {
        const $this = $(this);
        const isChecked = $this.is(":checked");
        const $chkAll = $(`.${chkAllClass}`);
        if (!isChecked) {
            $chkAll.prop("checked", false);
        }
        else {
            const $allSearchChk = $(`.${chkClass}`);
            let allChecked = true;
            for (let i = 0; i < $allSearchChk.length; i++) {
                allChecked = allChecked && $($allSearchChk[i]).prop("checked");
            }

            if (allChecked) {
                $chkAll.prop("checked", true);
            }
        }
    });

    $(`.${chkAllClass}`).on("click", function () {
        const $this = $(this);
        const isChecked = $this.is(":checked");

        if (isChecked) {
            const $allSearchChk = $(`.${chkClass}`);
            for (let i = 0; i < $allSearchChk.length; i++) {
                $($allSearchChk[i]).prop("checked", true);
            }
        }
    });
}

function initDefaultUploadEvents() {
    //let $defaultUploadContent = $(".dbhAddDokumentContainer");

    /* if ($defaultUploadContent.length > 0) {*/
    //$defaultUploadProxy.on("click", function (event, uploadInpuId, submitBtnId) {
    //const $input = $(uploadInpuId);

    $(document).on('change', '.dbhAddDokumentContainer #File', function () {
        if (this.files.length > 0) {
            const $this = $(this);
            const $label = $($this.find("label").get(0));
            const $uplChosenElement = $("#dbhTemplate");

            $this.closest(".dbhInput").addClass("hidden");
            $label.addClass('dbhUploadChoosen hidden');
            $uplChosenElement.removeClass("hidden");
            $uplChosenElement.find('.dbhBeleg').first().text(this.files[0].name);
            //$(submitBtnId).removeAttr("disabled");
        }
    });
    //$input.on("change", function () {
    //    if (this.files.length > 0) {
    //        const $this = $(this);
    //        const $label = $($this.find("label").get(0));

    //        $this.closest(".dbhInput").addClass("hidden");
    //        $label.addClass('dbhUploadChoosen hidden');
    //        $uplChosenElement.removeClass("hidden");
    //        $uplChosenElement.find('.dbhBeleg').first().text(this.files[0].name);
    //        $(submitBtnId).removeAttr("disabled");
    //    }
    //});

    /* Close-Funktionalität muss ausgelagert sein, da sonst beim edit-Popup das 
     * Close nicht funktioniert (wenn schon eine Datei ausgewählt ist)*/
    /* $(closeBtn).on("click", function () {*/
    $(document).on('click', '.dbhAddDokumentContainer #dbhTemplate .dbhUploadedBelegDelete', function () {
        const $uplChosenElement = $("#dbhTemplate");
        //const closeBtn = $uplChosenElement.find(".dbhUploadedBelegDelete").get(0);

        $uplChosenElement.addClass("hidden");
        const $input = $('.dbhAddDokumentContainer #File');
        $input.closest(".dbhInput").removeClass("hidden");
        $input.val('');
        //$(submitBtnId).attr('disabled', 'disabled');
    });
    //});

    /*  }*/

};

function initObjectHistory() {
    $(".objHistoryBtn").on("click", function () {
        const key = $(this).data("key");
        const type = $(this).data("type");

        return new dbh_ajax().sendGetRequest({
            actionName: "GetObjectHistoryPopup",
            controllerName: "Home",
            parameter: [["key", key], ["objName", type]],
            callbackSuccess: (ajaxResult: any) => {
                $(`#objHistory-placeholder`).html(ajaxResult.responseText);
                $("#ObjectHistoryPopup").show();

                $(".entryInfo").on("click", function () {
                    const $this = $(this);
                    $this.parent().find(".entryInfo").removeClass("active");
                    $this.addClass("active");

                    const number = $this.data("number");
                    const versionname = $this.data("versionname");
                    const versionname2 = $this.data("versionname2");
                    const isFirst = $this.data("first")


                    let otherNumber = null;
                    const $otherActiveEntry = $(`.entryInfo_${versionname2}.active`);

                    if ($otherActiveEntry.length > 0) {
                        otherNumber = $otherActiveEntry.data("number");
                    }

                    return new dbh_ajax().sendGetRequest({
                        actionName: "CompareHistoryEntries",
                        controllerName: "Home",
                        parameter: [["key", key], ["objName", type], ["number", number], ["otherNumber", otherNumber], ["isFirst", isFirst]],
                        callbackSuccess: (ajaxHistoryResult: any) => {
                            $(`#versionenDifferenceContainer`).html(ajaxHistoryResult.responseText);
                        }
                    });
                });
            }
        });
    });
}

function initInfoBanner() {
    const banner = $(".banner");
    if (banner != null && banner != undefined) {
        const bannerShowBtn = $(".bannerOpen");
        const cookie = dbh_helper.GetCookie("dbhInfoBanner");

        if (cookie.length === 0) {
            banner.addClass("show");
        }
        else {
            bannerShowBtn.addClass("show");
        }

        const bannerBtn = banner.find(".bannerBtn");
        bannerBtn.on("click", function () {
            banner.removeClass("show");
            bannerShowBtn.addClass("show");
            dbh_helper.SetCookie("dbhInfoBanner", "1", 1);
        });

        bannerShowBtn.on("click", function () {
            banner.addClass("show");
            bannerShowBtn.removeClass("show");
        });
    }
}
